import Popover from 'react-bootstrap/Popover'
import {OverlayTrigger} from 'react-bootstrap'
import React from 'react'
import Image from 'react-bootstrap/Image'

interface PopoverOrderPropsInterface {
    product: Object,
    composition: string,
    content: Element,
}

export function PopoverOrder({product, composition, content}: PopoverOrderPropsInterface) {
  return (
    <>
      <OverlayTrigger
        placement={'auto'}
        overlay={
          <Popover id={`popover-${product.idcompo}`}>
            <Popover.Header as="h3">{product.libcompo}</Popover.Header>
            <Popover.Body>
              <Image
                src={`https://cdn.florajet.com/produits/300/${product.idcompo}.jpg`}
                className={'img-fluid'}
                onError={(e) => {
                  e.target.src =
                    'https://www.monflorajet.com/v2/themes/extranet_v2/img/mini_def.png'
                }}
              />
              {composition}
            </Popover.Body>
          </Popover>
        }>
        {content}
      </OverlayTrigger>
    </>
  )
}
